// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-44ed569b]{margin:0 auto;line-height:46px;text-align:left;font-size:16px;color:#676767}.gb-td[data-v-44ed569b]{padding:8px 12px}.age[data-v-44ed569b]{max-width:200px}.age label[data-v-44ed569b]{white-space:unset;line-height:1.5em}.btn[data-v-44ed569b]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}.warning-message[data-v-44ed569b]{width:100%;display:block;padding:0 10px}", ""]);
// Exports
module.exports = exports;
